export const initials = (firstName, lastName) => {
  let result = ''
  if (firstName) {
    result = firstName.charAt(0)
  }
  if (lastName) {
    result = result + lastName.charAt(0)
  }
  if (result === '') {
    result = '--'
  }
  return result
}
